import SJButton from '@/components/SJButton'
import { getCertification, getRegistration } from '@/services/accredit'
import {
  Certification,
  CertificationListRes,
  ExaminationState,
  Registration,
  RegistrationListRes,
} from '@/services/types/accredit'
import { useEffect, useState, useMemo, useCallback } from 'react'
import SJNoData from '@/components/SJNoData'
import icons from '@/assets/icons'
import images from '@/assets/images'
import { useNavigate } from 'react-router-dom'
import SJSpace from '@/components/SJSpace'
import accredit from '@/stores/accredit'
import './index.less'

type Props = {
  playerId: string
}
const CertificationInfo = ({ playerId }: Props) => {
  const navigate = useNavigate()
  const [certification, setCertification] = useState<Certification[]>([])
  const [registrations, setRegistrations] = useState<Registration[]>([])
  const certificationShow = useMemo(() => {
    return certification.slice(0, 2)
  }, [certification])

  const getRecords = useCallback(async () => {
    if (!playerId) return

    try {
      const res1 = (await getCertification({
        applicant_id: playerId,
        // grade: 16,
        // certification_num: ''
      })) as unknown as CertificationListRes
      setCertification(res1.certification)

      const res2 = (await getRegistration({
        applicant_id: playerId,
        page: 1,
        size: 5,
        // broker_id: String(user.userInfo.id),
      })) as unknown as RegistrationListRes
      setRegistrations(res2.registrations)
    } catch (error) {}
  }, [playerId])

  useEffect(() => {
    getRecords()
  }, [getRecords])

  const goRegistration = () => {
    // Taro.navigateTo({
    //   url: '/packageAccredit/pages/grade/index',
    // })
    // if (user.curPlayerGroupMyRoleType) {
    //   accredit.applicant_id = playerId
    // } else {
    //   STToast.info('只有群组管理员才可以帮棋手报名')
    // }
    accredit.applicant_id = playerId
    navigate(`/registration/grade?playerId=${playerId}`)
  }

  const goResult = (item: any) => {
    navigate(`/registration/result?id=${item.id}&from=home`)
  }

  const showCertification = (index: number) => {
    navigate(`/registration/certificates?playerId=${playerId}&current=${index}`)
  }
  const goRegistrationList = () => {
    navigate(`/registration/list?playerId=${playerId}`)
  }

  const GradeIcon = (grade: number) => {
    return icons[`IconGrade${grade || 16}`]
  }
  const showRegisterNumber = (state: string) => {
    return ['paid', 'examining', 'examined', 'failed'].includes(state)
  }

  return (
    <div className="certification-info">
      <div
        className="register"
        style={{ backgroundImage: `url(${images.certification_bg})` }}
        onClick={goRegistration}
      >
        <div className="title">中国象棋协会</div>
        <div className="title">官方指定评测机构</div>
        <div className="register-bottom">
          <div className="see">评测证书可支持在线查验</div>
          <SJButton className="btn-register" size="small">
            评测报名
          </SJButton>
        </div>
      </div>
      {certificationShow.length ? (
        <>
          <SJSpace height={12} />
          <div className="list">
            <div className="list-title hoverClass" onClick={() => showCertification(0)}>
              <span>我的证书</span>
              <img className="icon-right" src={icons.IconRight} alt="" />
            </div>
            <div className="certification-list">
              {certificationShow.map((item, index) => (
                <div
                  className="list-item hoverClass"
                  key={item.id}
                  onClick={() => showCertification(index)}
                >
                  <img className="image" src={images.certification_image} alt="" />
                  <div className="name-wrap">
                    <div className="name">{item.grade}级证书</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : undefined}
      <SJSpace height={12} />
      <div className="register-list">
        <div className="list-title hoverClass" onClick={goRegistrationList}>
          <span>报名信息</span>
          <img className="icon-right" src={icons.IconRight} alt="" />
        </div>
        {registrations.length ? (
          registrations.map((item: Registration) => (
            <div className="list-item hoverClass" key={item.id} onClick={() => goResult(item)}>
              <img className="grade" src={GradeIcon(item.applying_for_grade)} alt="" />
              <div className="info">
                <div className="name oneline">{item.applicant_name}</div>
                <div className="number oneline">
                  准考证号：
                  {showRegisterNumber(item.examination_state) ? item.registration_num : '***'}
                </div>
              </div>
              <span className={`status status-${item.examination_state}`}>
                {ExaminationState[item.examination_state]}
              </span>
            </div>
          ))
        ) : (
          <SJNoData />
        )}
      </div>
    </div>
  )
}

export default CertificationInfo
